'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _atLeast = require('@marmalade/validation/lib/at-least');
var _atLeast2 = _interopRequireDefault(_atLeast);
var _atMost = require('@marmalade/validation/lib/at-most');
var _atMost2 = _interopRequireDefault(_atMost);
var _contactDetails = require('@marmalade/validation/lib/bundles/contact-details');
var _isAlphanumerical = require('@marmalade/validation/lib/is-alphanumerical');
var _isAlphanumerical2 = _interopRequireDefault(_isAlphanumerical);
var _oneByOne = require('@marmalade/validation/lib/one-by-one');
var _oneByOne2 = _interopRequireDefault(_oneByOne);
var _oneOf = require('@marmalade/validation/lib/one-of');
var _oneOf2 = _interopRequireDefault(_oneOf);
var _required = require('@marmalade/validation/lib/required');
var _required2 = _interopRequireDefault(_required);
var _validateIf = require('@marmalade/validation/lib/validate-if');
var _validateIf2 = _interopRequireDefault(_validateIf);
var _constants = require('../../constants');
var _vehicleQuestions = require('../shared/vehicle-questions');
var _vehicleQuestions2 = _interopRequireDefault(_vehicleQuestions);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var min = _constants.vehicleValue.min,
  max = _constants.vehicleValue.max;
exports.default = function (keptOvernightOptions, relationOptions, regYear, o) {
  return Object.assign({}, (0, _vehicleQuestions2.default)(keptOvernightOptions, relationOptions), {
    ownerEmail: _contactDetails.email,
    value: (0, _oneByOne2.default)((0, _required2.default)(), (0, _atLeast2.default)(min, 'The vehicle value must be greater than \xA3' + min), (0, _atMost2.default)(max, 'The vehicle value must be less than \xA3' + max), function (value, values) {
      return new Date().getFullYear() - regYear > 20 ? "We can't insure vehicles over 20 years old." : '';
    }),
    advertiser: (0, _validateIf2.default)(function () {
      return !o.guid;
    }, (0, _oneOf2.default)(o.advertiserKeys || [])),
    advertiserExtraInfo: (0, _validateIf2.default)(function () {
      return !o.guid && o.captureExtraAdvertiserData;
    }, (0, _isAlphanumerical2.default)()),
    instructor: (0, _validateIf2.default)(function () {
      return !o.guid && o.captureInstructor;
    }, (0, _isAlphanumerical2.default)('Please enter your driving instructor name'))
  });
};